import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { PAYMENT_TYPE } from '../enums';

@Pipe({
  name: 'paymentType'
})
export class PaymentTypePipe extends EnumConverter implements PipeTransform {
  enumeration = PAYMENT_TYPE;
}
